import type { AppStatusType } from '@/features/appStatus/types/appStatus';

const accents: Record<AppStatusType, { ring: string; soft: string; solid: string }> = {
  maintenance: {
    ring: 'ring-[#F5D0A9]',
    soft: 'bg-[#FFF7ED]',
    solid: 'text-[#C2410C]',
  },
  issue: {
    ring: 'ring-[#FECACA]',
    soft: 'bg-[#FEF2F2]',
    solid: 'text-[#B91C1C]',
  },
  demo: {
    ring: 'ring-[#C6E8DE]',
    soft: 'bg-[#F0FAF6]',
    solid: 'text-[#0D8A73]',
  },
  launch: {
    ring: 'ring-[#BFDBFE]',
    soft: 'bg-[#EFF6FF]',
    solid: 'text-[#1D4ED8]',
  },
  unknown: {
    ring: 'ring-[#E2E9E7]',
    soft: 'bg-[#F2F5F4]',
    solid: 'text-[#3E524F]',
  },
};

export function StatusVisual({ type }: { type: AppStatusType }) {
  const tone = accents[type];

  return (
    <div
      className={`relative mb-8 flex h-28 w-28 items-center justify-center rounded-full ${tone.soft} ring-8 ${tone.ring}`}
    >
      <div className={`absolute inset-3 rounded-full ${tone.soft} opacity-70`} />
      {type === 'maintenance' ? (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" className={tone.solid}>
          <path
            d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : null}
      {type === 'issue' ? (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" className={tone.solid}>
          <path
            d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M12 9v4M12 17h.01" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
        </svg>
      ) : null}
      {type === 'demo' ? (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" className={tone.solid}>
          <path
            d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
          />
          <circle cx="12" cy="12" r="3.5" stroke="currentColor" strokeWidth="1.7" />
        </svg>
      ) : null}
      {(type === 'launch' || type === 'unknown') ? (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" className={tone.solid}>
          <path
            d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : null}
    </div>
  );
}
